import { PageHero } from "@/components/Sections";
import { Reveal } from "@/components/Reveal";
import { Apple, Play, Car, Bell, Search, FileText, CalendarClock, Heart, ClipboardList, MessageSquare } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1520046045453-547e1175391e?w=1600";

const features = [
  { icon: Car, label: "Consulter nos véhicules disponibles" },
  { icon: Bell, label: "Recevoir les nouveaux véhicules" },
  { icon: Search, label: "Effectuer une recherche personnalisée" },
  { icon: FileText, label: "Demander une estimation ou un devis" },
  { icon: ClipboardList, label: "Demander une reprise ou un achat" },
  { icon: CalendarClock, label: "Prendre rendez-vous à l'atelier" },
  { icon: Heart, label: "Enregistrer vos véhicules favoris" },
  { icon: MessageSquare, label: "Suivre vos demandes & être notifié" },
];

export default function MobileApp() {
  return (
    <div data-testid="app-page">
      <PageHero
        overline="L'application AS AUTO"
        title="AS AUTO dans votre poche."
        subtitle="Retrouvez tous les services AS AUTO directement depuis votre smartphone. Ne ratez plus votre prochaine voiture."
        image={HERO}
      />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid gap-12 lg:grid-cols-2 items-center">
        <Reveal>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">Un espace client complet</p>
            <h2 className="font-display text-4xl font-bold text-white leading-tight">Tous nos services, au même endroit.</h2>
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.label} className="flex items-start gap-3 bg-[#121212] border border-white/10 rounded-sm p-4">
                  <f.icon className="h-5 w-5 text-[#C5A059] shrink-0 mt-0.5" />
                  <span className="text-sm text-neutral-300">{f.label}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <button data-testid="app-store-btn" className="flex items-center gap-3 bg-white text-black rounded-sm px-5 py-3 hover:opacity-90 transition-opacity active:scale-95">
                <Apple className="h-6 w-6" />
                <div className="text-left leading-tight"><span className="block text-[10px]">Télécharger sur l'</span><span className="block text-sm font-bold">App Store</span></div>
              </button>
              <button data-testid="play-store-btn" className="flex items-center gap-3 bg-white text-black rounded-sm px-5 py-3 hover:opacity-90 transition-opacity active:scale-95">
                <Play className="h-6 w-6" />
                <div className="text-left leading-tight"><span className="block text-[10px]">Disponible sur</span><span className="block text-sm font-bold">Google Play</span></div>
              </button>
            </div>
            <p className="mt-4 text-xs text-neutral-500">Application bientôt disponible sur iOS et Android.</p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-8 bg-[#C5A059]/10 blur-3xl rounded-full" />
            <div className="relative mx-auto w-[280px] aspect-[9/19] rounded-[2.5rem] border-[6px] border-neutral-800 bg-[#0a0a0a] overflow-hidden shadow-2xl">
              <div className="absolute top-0 inset-x-0 h-6 flex justify-center"><div className="mt-1 h-4 w-24 bg-black rounded-full" /></div>
              <div className="pt-10 px-4">
                <div className="flex items-baseline gap-1.5 px-1"><span className="font-display text-xl font-extrabold text-white">AS</span><span className="font-display text-xl font-extrabold text-[#C5A059]">AUTO</span></div>
                <div className="mt-4 rounded-lg overflow-hidden"><img src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600" alt="" className="w-full aspect-video object-cover" /></div>
                <div className="mt-3 space-y-2">
                  <div className="h-3 w-2/3 bg-white/15 rounded-full" />
                  <div className="h-3 w-1/3 bg-[#C5A059]/60 rounded-full" />
                </div>
                <div className="mt-4 grid grid-cols-2 gap-2">
                  {[0,1,2,3].map((i)=>(<div key={i} className="h-14 bg-white/5 border border-white/10 rounded-lg" />))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
